import { currentDevice } from '../../../../core/utils/currentDevice'
import { isDebugConsoleEnabled } from '../../../../utils/debug'

const componentStyleLoadPromises = new Map()

export function loadStyles({ name, folder = 'components', test_name = '' }) {
  const cacheKey = `${folder}/${name}/${test_name || ''}`
  if (componentStyleLoadPromises.has(cacheKey)) {
    return componentStyleLoadPromises.get(cacheKey)
  }

  const stylesStandard = [name, test_name ? `_${test_name}` : ''].join('')
  const stylesMobile = [stylesStandard, currentDevice.isMobile ? 'Mobile' : ''].join('')
  // If we are in mobile, try to load de Mobile version
  const loadPromise = import(`../../${folder}/${name}/${stylesMobile}.scss`).catch(mobileErr => {
    // If not available, load the Standard version
    return import(`../../${folder}/${name}/${stylesStandard}.scss`).catch(standardErr => {
      // If both fails, promise is rejected
      if (isDebugConsoleEnabled()) {
        console.warn(
          `Failed to load styles for ${name}. Mobile: ${mobileErr.message}, Standard: ${standardErr.message}`
        )
      }

      return undefined
    })
  })

  componentStyleLoadPromises.set(cacheKey, loadPromise)
  return loadPromise
}

const LoadStyles = {
  created() {
    if (this.$options.name) {
      loadStyles({ name: this.$options.name, test_name: this.testName })
    }
  },
}

export default LoadStyles
